export const BUSY_CHANNEL_NAME = "vkngx";
